import { ServicesGroup } from "utils/helpers/ServicesGroup"

export const getLastServiceGroup = (
    findServiceGroupId: number | undefined,
    serviceGroups: ServicesGroup[]
) => {
    return findServiceGroupId
        ? ServicesGroup.findServiceGroup(serviceGroups, findServiceGroupId)
        : undefined
}
